import axios from "axios";
// create an axios instance
let protocol =window.location.protocol;//协议
let host = window.location.host;//主机
const service = axios.create({
  // baseURL: "http://127.0.0.1:80/prod-api/web/os/query/", // url = base url + request url
  baseURL: protocol +"//" + host+"/prod-api/web/os/query/", // url = base url + request url
  timeout: 20000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== 200) {
      return Promise.reject(res.msg);
    } else {
      return res;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
